import React from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
// import { TrasnkModal } from "helpers/constants";
import toastr from "toastr";

export const AddFundModal = ({ visible, onClose }) => {
  const { user } = useSelector((state) => state?.Login);

  const copyToClipboard = (text) => {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
    } finally {
      document.body.removeChild(textarea);
    }
    toastr.success("Copied to clipboard!");
  };

  const onCloseHandler = () => {
    onClose && onClose();
  };

  return (
    <Modal
      className="add-funds-modal"
      show={visible}
      onHide={onCloseHandler}
      animation={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">Add funds</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="add-funds">
          <div className="tabs-container">
            <div className="p-4 cursor-pointer deposit-crypto">
              <svg
                width="22"
                height="22"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-2 "
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3"
                ></path>
              </svg>
              <span>Deposit crypto</span>
            </div>
            {/* <div
              className="p-4 cursor-pointer buy-with-card"
              onClick={() => {
                TrasnkModal.init();
                onClose();
              }}
            >
              <svg
                width="22"
                height="22"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-6 h-6 mr-2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
                ></path>
              </svg>
              <span> Buy with card </span>
            </div> */}
          </div>
          <div className="wallet-image text-center">
            <img src="/images/walletImg.png" width="150px" height="150px" />
            <p>
              Transfer funds from an exchange or another wallet to your wallet
              address below:
            </p>
          </div>
          <div
            onClick={() => copyToClipboard(user.walletAddress)}
            className="d-flex justify-content-between border p-2 items-center text-sm cursor-pointer text-center"
          >
            <span className="text-neutral-700 dark:text-neutral-300 text-center">
              {user?.walletAddress}
            </span>
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M18.05 9.19992L17.2333 12.6833C16.5333 15.6916 15.15 16.9083 12.55 16.6583C12.1333 16.6249 11.6833 16.5499 11.2 16.4333L9.79999 16.0999C6.32499 15.2749 5.24999 13.5583 6.06665 10.0749L6.88332 6.58326C7.04999 5.87492 7.24999 5.25826 7.49999 4.74992C8.47499 2.73326 10.1333 2.19159 12.9167 2.84993L14.3083 3.17493C17.8 3.99159 18.8667 5.71659 18.05 9.19992Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M12.5498 16.6583C12.0331 17.0083 11.3831 17.3 10.5915 17.5583L9.2748 17.9917C5.96646 19.0583 4.2248 18.1667 3.1498 14.8583L2.08313 11.5667C1.01646 8.25833 1.8998 6.50833 5.20813 5.44167L6.5248 5.00833C6.86646 4.9 7.19146 4.80833 7.4998 4.75C7.2498 5.25833 7.0498 5.875 6.88313 6.58333L6.06646 10.075C5.2498 13.5583 6.3248 15.275 9.7998 16.1L11.1998 16.4333C11.6831 16.55 12.1331 16.625 12.5498 16.6583Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
